import * as React from 'react';

interface LayoutProps {
}

export const Layout: React.FC<LayoutProps> = (props: React.PropsWithChildren<LayoutProps>) => {

    return (
      <div>
          {props.children}
      </div>
    );
}
